import React, { Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PageTitle from '../../components/pagetitle/PageTitle';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import SEO from '../../components/SEO/SEO';
import { seoData } from '../../utils/seoData';
import Logo from '../../images/logo.png'
import About from '../../components/about/about';
import MissionVision from '../../components/MissionVision/MissionVision';
import WhyChooseUs from '../../components/WhyChooseUs/WhyChooseUs';
import Certificates from '../../components/Certificates/Certificates';
import FunFact from '../../components/FunFact/FunFact';
import Testimonial from '../../components/Testimonial/Testimonial';
// import ServiceSection from '../../components/ServiceSection/ServiceSection';
import TeamSection from '../../components/TeamSection/TeamSection';
import { Helmet } from 'react-helmet-async';
// import BlogSection from '../../components/BlogSection/BlogSection';

const AboutPage = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.querySelector(location.hash);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 100);
            }
        }
    }, [location]);

    return (
        <Fragment>
            <SEO 
                title={seoData.about.title}
                description={seoData.about.description}
                keywords={seoData.about.keywords}
            />

           

            <Navbar Logo={Logo} />
            <PageTitle pageTitle={'About Us'} pagesub={'About'} customClass={'about-page-banner'} />
            <About />
            <MissionVision />
            <WhyChooseUs />
            <Certificates />
            {/* <ServiceSection/>  */}
            <FunFact />
            {/* <TeamSection/> */}
            <Testimonial />
            {/* <BlogSection/>  */}
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default AboutPage;
